import styled from 'styled-components'

export const Bookings = styled.div `
color: black;
margin: 45px 0px;
border-radius: 0px;
background-color: white;
overflow: hidden;
border: 1px solid rgba(0, 0, 0, 0.15);
`

export const Center = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const ButtonVerticalCenter = styled.div `
  margin-top: 50px;
  @media (max-width: 500px) {
    margin-top: 10px;
  }
`

export const BookingInfo = styled.p `
  height: 45px;
  margin-left: 55px;
  color: black;
  line-height: 40px;
  @media (max-width: 676px) {
      line-height: 20px;
  }
  opacity: 1;
  margin: 0px;
`

export const Booking = styled.div `
  height: 100%;
`

export const Heading = styled.h2 `
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
`


// WEBPACK FOOTER //
// /src/components/internal/ActiveBookingsStyle.js